import { ArrowRight, ErrorOutline, Warning } from '@mui/icons-material';
import { IconButton, Tooltip } from '@mui/material';
import { action, runInAction, makeObservable } from 'mobx';
import {  observer } from 'mobx-react';
import React from 'react';
import { Processo } from '../../modelo';
import { MovimentoGEDTO } from '../../modelo/MinutaMovimentos';
import MovimentoService from '../../services/MovimentoService';
import CategoriasStore from '../../store/CategoriasStore';
import MovimentoCNJStore from '../../store/MovimentoCNJStore';

interface IPropsMovimento {
    usarCategoria?: false;
    movimento: MovimentoGEDTO;
    processo: Processo;
    emLote?: boolean;
    preenchido?: never;
    descricaoCategoria?: never;
}

interface IPropsCategoria {
    usarCategoria: true;
    movimento?: never;
    processo?: Processo;
    emLote?: boolean;
    preenchido: boolean;
    descricaoCategoria: string;
}

type IPropsBotaoComplementoMovimento = IPropsMovimento | IPropsCategoria;

class BotaoComplementoMovimento extends React.Component<IPropsBotaoComplementoMovimento> {
    handleClickAbrirModal = async (event: React.MouseEvent<HTMLButtonElement>) => {
        event.currentTarget.blur();
        await this.abrirModal();
    };

    abrirModal = async () => {
        if (!this.props.usarCategoria) {

            await MovimentoService.recuperarOpcoesEComplementos(this.props.processo, this.props.movimento);

            runInAction(() => {
                MovimentoCNJStore.modalComplementosOpen = true;
                MovimentoCNJStore.idProcessoModalOpen = this.props.processo.identificadorProcesso;
                MovimentoCNJStore.codMovimentoModalOpen = this.props.movimento.codMovimentoCnj;
                MovimentoCNJStore.idMovimento = this.props.movimento.id;
            });
        } else {
            runInAction(() => {
                CategoriasStore.modalComplementosMovimento = true;
                CategoriasStore.descricaoCategoriaModalMovimento = this.props.descricaoCategoria;
            });
        }
    };

    constructor(props: IPropsBotaoComplementoMovimento) {
        super(props);

        makeObservable(this, {
            handleClickAbrirModal: action,
            abrirModal: action,

});
    }

    get preenchido() {
        return this.props.movimento?.isComplementosPreenchidos || this.props.preenchido;
    }

    get complementoAutomatico() {
        return this.props.movimento?.isComplementosPreenchidos && this.props.movimento.complementosPossiveis.length > 0 && this.props.movimento.complementosAutomaticosSetados;
    }

    render() {
        const cor = this.preenchido ? 'default' : 'secondary';
        const icone = this.preenchido ? <ArrowRight /> : <Warning color='warning' />;
        const iconeComplementoAutomatico = this.complementoAutomatico ? <Tooltip title='Complemento preenchido automaticamente'><ErrorOutline color='info' /></Tooltip> : null;
        const tooltip = this.props.emLote ? 'Complementos deverão ser indicados individualmente' : 'Favor indicar o complemento do movimento';
        return (
            <Tooltip disableFocusListener title={this.preenchido ? '' : tooltip}>
                <IconButton size='small' color={cor as 'secondary' | 'default'} onClick={this.handleClickAbrirModal}>
                    {icone} {iconeComplementoAutomatico}
                </IconButton>
            </Tooltip>
        );
    }
}

export default observer(BotaoComplementoMovimento);
